import { Agent } from 'config/Agent';

import { LastSearch } from 'types/legacy/LastSearch';

interface CreateLastSearchObjectProps {
    searchUrl: string;
    urlDomain: string;
    label: string;
    pathNameWithParams: string;
    lastSearchId: number;
    ssoId?: number;
}

export const createLastSearchObject = ({
    searchUrl,
    urlDomain,
    label,
    pathNameWithParams,
    lastSearchId,
    ssoId,
}: CreateLastSearchObjectProps): Partial<LastSearch> => {
    return {
        formData: '',
        type: 'searches',
        formType: 'package',
        urlParams: pathNameWithParams.replace('/suche', 'suche'),
        urlDomain: urlDomain.replace('https://', '').replace('http://', ''),
        destinationLabel: label,
        regionName: '',
        errorMessages: '',
        prefillAllowed: true,
        ssoId: ssoId ?? 0,
        agent: Agent.Urlaub,
        id: lastSearchId,
        url: searchUrl.replace('https://', '').replace('http://', ''),
        itemType: 'searches',
    };
};
